
import { Teleport } from "vue";
export default {
    components: { Teleport },
};
